import { render, staticRenderFns } from "./EnrollSection.vue?vue&type=template&id=6c5ee560&"
import script from "./EnrollSection.vue?vue&type=script&lang=js&"
export * from "./EnrollSection.vue?vue&type=script&lang=js&"
import style0 from "./EnrollSection.vue?vue&type=style&index=0&id=6c5ee560&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports